import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import WrapperContainer from 'redux/containers/pages/legislation/WrapperContainer'

const ConnectedWrapper = (props) => {
  const {
    group,
    path,
    admin,
    publisher,
    publishedId,
    versions,
    actSections
  } = props

  return (
    <ResponseConsumer
      responses={[
        group,
        path,
        admin,
        publisher,
        publishedId,
        versions,
        actSections
      ]}
      skeleton='legislation-accordion'
      content={() => <WrapperContainer {...props} />}
    />
  )
}

export default ConnectedWrapper
